// Background colors
const backgroundColor = "#0C0C0C";
const backgroundPaperColor = "#222";
const darkBlackColor = "#111";
const blackColor = "#000000";
const dialogTitleBackground = "#343434";

// Button colors
const purpleColor = "#861B55";

// Text colors
const whiteColor = "#FFFFFF";
const lightWhiteColor = "#E3E3E3";
const lightPurpleColor = "#B02470";
const lightBlueColor = "#4EB0E2";
const greyColor = "#707070";
const lightGreyColor = "#c0c9d2";

// Action colors
const lightRedColor = "#FF6760";
const redColor = "#D31F33";

const ThemeColors = {
  backgroundColor,
  backgroundPaperColor,
  dialogTitleBackground,
  whiteColor,
  darkBlackColor,
  lightWhiteColor,
  purpleColor,
  lightPurpleColor,
  greyColor,
  lightBlueColor,
  lightGreyColor,
  blackColor,
  lightRedColor,
  redColor,
};

export default ThemeColors;
